import { useState } from 'react';
// @mui
import { Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Swal from 'sweetalert2';
import Iconify from '../Iconify';
import CONFIG from '../../CONFIG.json';
import { workWithLocalStorage, buildBody, isEmpty } from '../../auxiliares/funciones';
import { useCentro } from '../../contextos/CentroContext';

// ----------------------------------------------------------------------

export default function LoginForm(props) {
  const { centro } = useCentro();

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const FormValues = {
    usuario: '',
    contrasena: '',
  };

  const actualizaCampo = (input) =>{
    const nombre = input.target.name
    const valor = input.target.value
    FormValues[nombre] = valor
  }

  const onSubmit = async () => {
    setLoading(true);
    // eslint-disable-next-line react/prop-types
    props.setLoader(true);
    const bodyJson = JSON.stringify(buildBody('', { ...FormValues, centroId: centro.id }));

    try {
      const response = await fetch(`${CONFIG.api}login`, {
        method: 'POST',
        body: bodyJson,
        headers: {
          'Content-Type': 'application/json',
          'x-centro-id': centro.id
        }
      });

      const text = await response.text();
      let result = {};
      try {
        result = JSON.parse(text);
      } catch (e) {
        result = { error: 1, errorMessage: `Error HTTP ${response.status} del servidor` };
      }

      if (response.ok && result.error === 0 && !isEmpty(result.data)) {
        workWithLocalStorage('set', 'usuario', result.data);
        window.location.reload();
      } else {
        // eslint-disable-next-line react/prop-types
        props.setLoader(false);
        Swal.fire({
          icon: 'error',
          title: 'Error de acceso',
          text: isEmpty(result.data)
            ? (result.errorMessage || 'Usuario y/o Contraseña incorrectos!')
            : result.errorMessage,
          confirmButtonText: 'Ok'
        });
        setLoading(false);
      }
    } catch (err) {
      // eslint-disable-next-line react/prop-types
      props.setLoader(false);
      Swal.fire({
        icon: 'error',
        title: 'Error de conexión',
        text: `No se pudo comunicar con el servidor backend: ${err.message}`,
        confirmButtonText: 'Ok'
      });
      setLoading(false);
    }
  };

  return (
    <form>
      <Stack spacing={3}>
        <TextField name="usuario" label="Usuario" InputLabelProps={{ shrink: true }} onChange={(e)=>actualizaCampo(e)} />

        <TextField
          name="contrasena" InputLabelProps={{ shrink: true }}
          label="Contraseña" onChange={(e)=>actualizaCampo(e)}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <LoadingButton onClick={()=>onSubmit()} fullWidth sx={{ my: 2 }} size="large" type="submit" variant="contained" loading={loading}>
        Acceder
      </LoadingButton>
    </form>
  );
}
